export default {
    /* c - correlation id
     * r - response code
     */
    PinRequest: {
        datapoint: {
            name: 'ExtPinRequest',
            customData: function (c, r) { return [c, r]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map